import { z } from "zod";
import { gstSchema } from "./common";

export const distributorBrandingSchema = z.object({
  id: z.number(),
  distributor: z.number(),
  brand_name: z.string().refine((value) => value.trim() !== "", {
    message: "Brand name is required",
  }),
  tag_line: z.string(),
  brand_logo: z.string().or(z.instanceof(File)),
  profile_bio: z.string(),
  brand_qr: z.string(),
  background_image: z.string().or(z.instanceof(File)).nullable().optional(),
  subdomain_name: z.string().optional(),
  modified_at: z.string().optional(),
});

export const distributorProfileSchema = z.object({
  arn_code: z.string(),
  email: z.string(),
  euin: z.string(),
  name: z.string(),
  phone_number: z.string(),
  declaration_link: z.string().nullable(),
  sif_euin: z.string().nullable().optional(),
  gift_city_flag: z.boolean().optional(),
  handle: z.string(),
  gst_number: z.union([z.literal(""), gstSchema]).nullable(),
});
